function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import DashCard from '@rd-web-markets/shared/dist/dashboards/components/DashCard';
import PieChart from '@rd-web-markets/shared/dist/dashboards/components/PieChart';
const CostCollectedProjectsPieChart = _ref => {
  let {
    dashboardData,
    ...props
  } = _ref;
  const labels = ['Not Started', 'In Progress', 'Completed'];
  const series = [dashboardData?.eligibility_assessment_statuses?.not_started || 0, dashboardData?.eligibility_assessment_statuses?.in_progress || 0, dashboardData?.eligibility_assessment_statuses?.completed || 0];
  return /*#__PURE__*/React.createElement(DashCard, _extends({}, props, {
    title: "Eligibility Assessment"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '25px'
    }
  }), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: series,
    label: 'Total Projects'
  }));
};
export default CostCollectedProjectsPieChart;